import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useAdviceHttp } from '@/core/api/advices'
import { Advice, AdvicePayload } from '@/core/models/advice'

export type AdviceCollection = {
    data: Array<Advice>,
    meta?: MetaPayload,
    links?: any
}

const state: AdviceCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const adviceCollection: Module<AdviceCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: AdviceCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: AdvicePayload) => {
                state.data.push(new Advice(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useAdviceHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: AdviceCollection): AdviceCollection => {
            return state
        }
    }
}
